module.exports = __webpack_public_path__ + "img/b.6d67147b.jpg";